<template>
  <b-modal id="EmployeeFolderInfo" scrollable size="lg" centered hide-footer>
    <template #modal-title>
      <h3>
        <img src="@/assets/images/employeeFolders.svg" class="icon-lg" />
        {{ $t("employeeFolders.data") }}
      </h3>
    </template>
    <div class="row">
      <DataLabelGroup
        :className="'col-lg-6'"
        :value="employeeFolderData.employeeFolderCode"
        :title="$t('employeeFolders.code')"
        :imgName="'number.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-6'"
        :value="employeeFolderData.employeeFolderNameAr"
        :title="$t('employeeFolders.nameAr')"
        :imgName="'employeeFolders.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-6'"
        :value="employeeFolderData.employeeFolderNameEn"
        :title="$t('employeeFolders.nameEn')"
        :imgName="'employeeFolders.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-6'"
        :value="employeeFolderData.employeeFolderNameUnd"
        :title="$t('employeeFolders.nameUnd')"
        :imgName="'employeeFolders.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-6'"
        :value="employeeFolderData.employeeFolderDescriptionAr"
        :title="$t('employeeFolders.descriptionAr')"
        :imgName="'description.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-6'"
        :value="employeeFolderData.employeeFolderDescriptionEn"
        :title="$t('employeeFolders.descriptionEn')"
        :imgName="'description.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-6'"
        :value="employeeFolderData.employeeFolderDescriptionUnd"
        :title="$t('employeeFolders.descriptionUnd')"
        :imgName="'description.svg'"
      />
      <DataLabelGroup
        :className="'col-lg-6'"
        :value="employeeFolderData.employeeFolderNotes"
        :title="$t('notes')"
        :imgName="'notes.svg'"
      />
    </div>
  </b-modal>
</template>

<script>
import DataLabelGroup from "@/components/general/DataLabelGroup.vue";
import { setDataMultiLang, timeToLang } from "@/utils/functions";

export default {
  name: "EmployeeFolderInfo",
  components: {
    DataLabelGroup,
  },
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["employeeFolderData"],
  methods: {
    timeToLang(time) {
      return timeToLang(time, this.language);
    },
    setDataMultiLang(lang, dataAr, dataEn) {
      return setDataMultiLang(lang, dataAr, dataEn);
    },
  },
};
</script>

<style scoped lang="scss"></style>
